import { Box, Typography, Alert, AlertTitle } from '@mui/material';
import { CheckCircle, Warning, Error, Info } from '@mui/icons-material';

export type StepFeedbackType = 'error' | 'success' | 'warning' | 'info';

interface StepFeedbackProps {
  type: StepFeedbackType;
  title?: string;
  messages: string[];
}

const FEEDBACK_ICONS: Record<StepFeedbackType, React.ReactNode> = {
  error: <Error />,
  success: <CheckCircle />,
  warning: <Warning />,
  info: <Info />,
};

const FEEDBACK_COLORS: Record<StepFeedbackType, 'error' | 'success' | 'warning' | 'info'> = {
  error: 'error',
  success: 'success',
  warning: 'warning',
  info: 'info',
};

export const StepFeedback = ({ type, title, messages }: StepFeedbackProps) => {
  if (!messages.length) return null;

  return (
    <Alert
      severity={FEEDBACK_COLORS[type]}
      icon={FEEDBACK_ICONS[type]}
      sx={{ mb: 2 }}
    >
      {title && <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>}
      <Box component="ul" sx={{ m: 0, pl: 2 }}>
        {messages.map((msg, i) => (
          <li key={i}>
            <Typography variant="body2">{msg}</Typography>
          </li>
        ))}
      </Box>
    </Alert>
  );
};